import { Table } from '@ztechapps/webui.data-tools'
import { useMetadataContext } from './Context'
import { ListHeader } from './ListHeader'
import { ListRow } from './ListRow'
import { TrailingEmptyRow } from './TrailingEmptyRow'

/**
 * The Specifications spreadsheet grid.
 *
 * Uses `row={ListRow}` (not the deprecated `createRow`) so `<Table>`'s `MemoizedRow` wraps every
 * row in `<HandlePropsProvider>` — without that provider, `<TableCellDragHandle>` reads `null` from
 * `useHandleProps()` and the drag never starts.
 *
 * The trailing empty row is rendered via the `foot` slot (`<tfoot>`) so it sits OUTSIDE the
 * `<tbody>` that `useDragSort` tracks — it has no `data-drag-sort-index`, cannot be dragged, and
 * cannot be a drop target. Committed rows in `list` are the only draggable items.
 *
 * `onReorder` splices `list` in `MetadataProvider` and marks the list dirty; the mutation only
 * fires on Save.
 */
export const List = () => {
  const { list, onReorder, containerProps } = useMetadataContext()

  // The wrapper `<div>` carries the delegated handlers from `useSpreadsheetNavigation`: a single
  // `onKeyDown` and a capture-phase `onMouseDownCapture` that blurs the editor on outside presses.
  // Every cell key event bubbles up to it (the active cell's `<td>` in view mode, or its input in
  // edit mode), so the handler stays bound once instead of re-binding per cell on every active-cell
  // change. `showEmptyContent={false}` keeps head + tfoot mounted when `list` is empty so the
  // auto-trailing empty row is always reachable as the entry point.
  return (
    <div {...containerProps}>
      <Table
        showEmptyContent={false}
        head={<ListHeader />}
        dataArray={list}
        row={ListRow}
        responsive={''}
        onDragSort={onReorder}
        foot={<TrailingEmptyRow />}
      />
    </div>
  )
}
